
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import heroImg from '../../../assets/prestige/mainFeed.jpg'
import logo from '../../../assets/prestige/logo.jpeg'

import ameneties1 from '../../../assets/prestige/ameneties-1.jpg'
import ameneties2 from '../../../assets/prestige/ameneties-2.jpeg'
import ameneties3 from '../../../assets/prestige/ameneties-3.jpg'
import ameneties4 from '../../../assets/prestige/ameneties-4.jpg'
import ameneties5 from '../../../assets/prestige/ameneties-5.jpg'
import ameneties6 from '../../../assets/prestige/ameneties-6.jpg'
import ameneties7 from '../../../assets/prestige/ameneties-7.jpg'
import ameneties8 from '../../../assets/prestige/ameneties-8.webp'
import ameneties9 from '../../../assets/prestige/ameneties-9.jpg'
import ameneties10 from '../../../assets/prestige/ameneties-10.png'

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';


const PrestigeCity = () => {
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);
    const [selectedImgIndex, setSelectedImgIndex] = useState(null);

    const ameneties = [
        { id: 0, img: ameneties1, title: "Bang on NH-24 Exp." },
        { id: 1, img: ameneties2, title: "Luxury architecture" },
        { id: 2, img: ameneties3, title: "Luxury deck apartments" },
        { id: 3, img: ameneties4, title: "5 Star tower lobby" },
        { id: 4, img: ameneties5, title: "Triple height tower entrance" },
        { id: 5, img: ameneties6, title: "Most luxury layout" },
        { id: 6, img: ameneties7, title: "Luxury open space & landscaping" },
        { id: 7, img: ameneties8, title: "Maximum vantilated apartments" },
        { id: 8, img: ameneties9, title: "Thermal controlled swimming pools" },
        { id: 9, img: ameneties10, title: "Expressway facing apartments" }
    ]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index) => {
        setOpenImgModal(false);
        setSelectedImgIndex(index);
        setTimeout(() => {
            setOpenImgModal(true);
        }, 100);
    }


    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                </div>
            </div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <h3 className="font-semibold text-xl md:text-2xl mb-2">Overview</h3>
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Prestige Group has a diverse portfolio that includes residential, commercial, retail, leisure, and
                                hospitality segments. The company has completed over 300 projects, spanning a developable area of
                                more than 180 million square feet. Some of their notable projects include Prestige Shantiniketan, UB
                                City, Prestige Golfshire, and The Forum malls               </p>
                            <h3 className="font-semibold text-xl md:text-2xl mb-2">Achievements</h3>
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Prestige Group is known for its commitment to quality construction and customer satisfaction. The
                                company has been graded CRISIL DA1+ by CRISIL and enjoys a credit rating of ICRA A+. They have
                                also received numerous awards and accolades for their innovative and landmark developments.             </p>

                            <h3 className="font-semibold text-xl md:text-2xl mb-2">Upcoming Launch</h3>
                            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                                </div>
                            </div>

                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Prestige City is the latest offering from the Prestige Group, located in Siddharth Vihar,
                                Ghaziabad, along NH 24. This luxurious residential project spans over 64 acres and is designed to
                                provide a contemporary and comfortable lifestyle for its residents.
                            </p>

                            <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>
                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Apartment Types:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The project offers a variety of apartment configurations, including 2, 3, 4,
                                        and 5 BHK units, catering to different family sizes and preferences.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Open Area:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        With 80% open area, residents can enjoy ample green spaces and a serene
                                        environment.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Clubhouse:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        A lavish 1,55,000+ sq. ft. clubhouse equipped with world-class amenities.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Security:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        24-hour security ensures the safety and well-being of all residents.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Location:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The project is strategically located with excellent connectivity to major landmarks,
                                        including a 5-minute drive to Noida Sector 62 Metro Station and a 30-minute drive to IGI Airport.
                                    </p>
                                </div>
                            </section>


                            <h2 className="text-2xl md:text-3xl font-bold my-4">Highlights :</h2>
                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Gymnasium:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        A well-equipped gym for fitness enthusiasts.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Parks:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Multiple parks within the community for relaxation and recreation.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Sustainable Features :</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Eco-friendly initiatives such as rainwater harvesting, solar panels, and
                                        energy-efficient lighting.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Developer</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The Prestige Group, established in 1986, is one of India's leading real estate developers. With a
                                        portfolio of over 300 completed projects and numerous ongoing and upcoming projects, the group is
                                        known for its innovation and quality.
                                    </p>
                                </div>
                            </section>
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Prestige City in Siddharth Vihar, Ghaziabad, promises a luxurious and convenient lifestyle, making it
                                an ideal choice for families and professionals alike.
                            </p>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 my-4">
                    Projects Highlights
                </h2>
                {openImgModal && (
                    <ImageModal
                        images={ameneties.map((item) => item.img)}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {ameneties.map((data, index) => (
                        <div key={index}
                            onClick={() => handleOpenModal(index)}
                            className="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden bg-white">
                            <div className="relative">
                                <img
                                    src={data.img}
                                    alt={data.title}
                                    className="w-full h-56 object-cover transition-transform duration-300 transform hover:scale-105"
                                />
                            </div>
                            <div className="px-5 py-3">
                                <h3 className="text-gray-700 font-semibold">{data.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default PrestigeCity